import {
  FormatSize as HeadingIcon,
  FormatListBulleted as BulletListIcon,
  FormatListNumbered as NumberedListIcon,
  CheckBox as TaskListIcon,
  FormatQuote as BlockquoteIcon,
  Code as CodeBlockIcon,
  TableChart as TableIcon,
  Remove as HorizontalRuleIcon,
  FormatClear as ToggleListIcon,
} from '@material-ui/icons';

export const GROUPS = [
  {
    name: 'format',
    title: 'Format',
    commands: [
      {
        name: 'heading1',
        label: 'Heading 1',
        icon: HeadingIcon,
        description: 'High priority section title',
        aliases: ['h1'],
        action: (editor) => editor.chain().focus().setHeading({ level: 1 }).run(),
      },
      {
        name: 'heading2',
        label: 'Heading 2',
        icon: HeadingIcon,
        description: 'Medium priority section title',
        aliases: ['h2'],
        action: (editor) => editor.chain().focus().setHeading({ level: 2 }).run(),
      },
      {
        name: 'heading3',
        label: 'Heading 3',
        icon: HeadingIcon,
        description: 'Low priority section title',
        aliases: ['h3'],
        action: (editor) => editor.chain().focus().setHeading({ level: 3 }).run(),
      },
      {
        name: 'bulletList',
        label: 'Bullet List',
        icon: BulletListIcon,
        description: 'Unordered list of items',
        aliases: ['ul'],
        action: (editor) => editor.chain().focus().toggleBulletList().run(),
      },
      {
        name: 'numberedList',
        label: 'Numbered List',
        icon: NumberedListIcon,
        description: 'Ordered list of items',
        aliases: ['ol'],
        action: (editor) => editor.chain().focus().toggleOrderedList().run(),
      },
      {
        name: 'taskList',
        label: 'Task List',
        icon: TaskListIcon,
        description: 'Task list with todo items',
        aliases: ['todo'],
        action: (editor) => editor.chain().focus().toggleTaskList().run(),
      },
      {
        name: 'toggleList',
        label: 'Toggle List',
        icon: ToggleListIcon,
        description: 'Toggles can show and hide content',
        aliases: ['toggle'],
        action: (editor) => editor.chain().focus().setDetails().run(),
      },
      {
        name: 'blockquote',
        label: 'Blockquote',
        icon: BlockquoteIcon,
        description: 'Element for quoting',
        action: (editor) => editor.chain().focus().setBlockquote().run(),
      },
      {
        name: 'codeBlock',
        label: 'Code Block',
        icon: CodeBlockIcon,
        description: 'Code block with syntax highlighting',
        shouldBeHidden: (editor) => editor.isActive('columns'),
        action: (editor) => editor.chain().focus().setCodeBlock().run(),
      },
    ],
  },
  {
    name: 'insert',
    title: 'Insert',
    commands: [
      {
        name: 'table',
        label: 'Table',
        icon: TableIcon,
        description: 'Insert a table',
        shouldBeHidden: (editor) => editor.isActive('columns'),
        action: (editor) =>
          editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false }).run(),
      },
      {
        name: 'horizontalRule',
        label: 'Horizontal Rule',
        icon: HorizontalRuleIcon,
        description: 'Insert a horizontal divider',
        aliases: ['hr'],
        action: (editor) => editor.chain().focus().setHorizontalRule().run(),
      },
    ],
  },
];

export default GROUPS;
